/**
 * Yotpo referral flow for a referee (someone who followed a friend's
 * referral link):
 *
 * 1. Land on the home page: done by snippets/yotpo-referral-landing-redirect.liquid,
 *    rendered at the top of the head, so the landing page never paints.
 *
 * 2. Redirect the popup's buttons. The popup itself stays Yotpo's default;
 *    only where its two buttons go changes:
 *
 *      See how your purchase gives back  ->  /pages/my-impact
 *      Start shopping                    ->  /collections/new-arrivals
 *
 *    Listens in the capture phase so it runs before Yotpo's own click
 *    handler, and only acts on real clicks by the visitor.
 *
 * 3. Stop the page scrolling behind the popup while it is open.
 */
(function () {
  'use strict';

  // Yotpo's referred-friend popup. The current widget wraps it in
  // .yotpo-widget-referral-friend; the older one, still served on some Yotpo
  // stores, in .yotpo-widget-referred-friend.
  var POPUP_SELECTOR = '.yotpo-widget-referral-friend, .yotpo-widget-referred-friend';
  var OVERLAY_SELECTOR =
    '.yotpo-widget-referral-friend .yotpo-loyalty-popup-overlay, ' +
    '.yotpo-widget-referred-friend .yotpo-loyalty-popup-overlay';

  var REDIRECTS = {
    '.yotpo-rewards-page-button': '/pages/my-impact',
    '.yotpo-start-button': '/collections/new-arrivals'
  };

  // Yotpo renders the overlay only while the popup is open, and removes it
  // on close, so its presence is the open state. Watched on every page rather
  // than only with sref_id in the URL, in case Yotpo drops the parameter
  // before this deferred script runs.
  //
  // html[scroll-lock] (base.css) alone doesn't hold on iOS Safari or the
  // app's WebView, which keep scrolling the page under overflow: hidden, so
  // the body is also pinned where it was and put back on close.
  var locked = false;
  var lockedScrollY = 0;

  function lockScroll() {
    var body = document.body.style;
    lockedScrollY = window.scrollY;
    document.documentElement.setAttribute('scroll-lock', '');
    body.position = 'fixed';
    body.top = -lockedScrollY + 'px';
    body.left = '0';
    body.right = '0';
    body.width = '100%';
  }

  function unlockScroll() {
    var body = document.body.style;
    document.documentElement.removeAttribute('scroll-lock');
    body.position = '';
    body.top = '';
    body.left = '';
    body.right = '';
    body.width = '';
    // 'instant': html has scroll-behavior: smooth, which would animate it.
    window.scrollTo({ top: lockedScrollY, behavior: 'instant' });
  }

  function syncScrollLock() {
    var open = !!document.querySelector(OVERLAY_SELECTOR);
    if (open === locked) return;
    locked = open;
    if (open) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  new MutationObserver(syncScrollLock).observe(document.body, { childList: true, subtree: true });
  syncScrollLock();

  document.addEventListener('click', function (event) {
    // Only a real click by the visitor: a click Yotpo fires itself from code
    // (e.g. while opening the popup) must not send them off the home page.
    if (!event.isTrusted || !(event.target instanceof Element)) return;

    var popup = event.target.closest(POPUP_SELECTOR);
    if (!popup) return;

    for (var selector in REDIRECTS) {
      if (event.target.closest(selector)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(REDIRECTS[selector]);
        return;
      }
    }
  }, true);
})();
